import { Trans } from '@lingui/macro';
import styled from '@emotion/styled';
import { NumberInput, NumberInputProps } from 'components';
import { parseNumber } from './transforms';

type NumberProps = {
  from?: number | '';
  to?: number | '';
  onChange: (from?: number | '', to?: number | '') => void;
  onBlur: () => void;
  onKeyDown?: NumberInputProps['onKeyDown'];
};

export const Number = ({ from, to, onChange, onBlur, onKeyDown }: NumberProps) => {
  return (
    <FromTo>
      <NumberInput
        placeholder="e.g. 1"
        variant="outlined"
        value={String(from)}
        allowSignedValues
        onChange={e => {
          onChange((e.target.value ?? '') as unknown as number, to);
        }}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
      <Trans>to</Trans>
      <NumberInput
        placeholder="e.g. 9"
        variant="outlined"
        value={String(to)}
        allowSignedValues
        onChange={e => {
          onChange(from, (e.target.value ?? '') as unknown as number);
        }}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
    </FromTo>
  );
};

const FromTo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  > div {
    min-width: 186px;
  }
`;
